import { OrderStatus } from "@/services/marketplace/order";
import { fetchSaleList } from "@/services/marketplace/order/sales";
import { readonly } from "vue";

const count = ref(0);
const isSomethingNew = computed(() => count.value > 0);

const CheckInterval = 120000;
let timer: ReturnType<typeof setInterval> | null = null;

export function useNewSaleCheck() {
  const startAutocheck = () => {
    if (timer !== null) {
      return;
    }

    check();
    timer = setInterval(() => check(), CheckInterval);
  };

  const stopAutocheck = () => {
    if (timer !== null) {
      clearInterval(timer);
    }
  };

  const clear = () => {
    count.value = 0;
  };

  const check = async () => {
    const perPage = 50; // Pagination not implemented in API yet. But let's read 50 orders - it's very unlikely user will have order needing attention between older orders than last 50.
    const page = 0;
    const orders = await fetchSaleList(page, perPage);
    count.value = orders.orders.filter((o) => o.status === OrderStatus.Packaging).length;
  };

  return {
    isSomethingNew: readonly(isSomethingNew),
    count: readonly(count),

    startAutocheck,
    stopAutocheck,

    clear,
  };
}
